import { ComponentsProps } from '@material-ui/core/styles/props';

export const initializeComponentsProps = (config?: ComponentsProps): ComponentsProps => {
  return {
    ...config,
    MuiChip: {
      size: 'small',
    },
    MuiButtonBase: {},
    MuiTabs: {
      variant: 'scrollable',
    },
  };
};
